type SectionLabelProps = {
  index: string;
  kicker: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
};

export default function SectionLabel({ index, kicker, title, desc, align = 'left' }: SectionLabelProps) {
  const isCenter = align === 'center';

  return (
    <div className={isCenter ? 'mx-auto max-w-2xl text-center' : ''}>
      <div className={`flex items-center gap-3 ${isCenter ? 'justify-center' : ''}`}>
        <span className="font-heading text-sm font-bold text-primary-600">{index}</span>
        <span className="h-px w-8 bg-primary-300" />
        <span className="text-xs tracking-[0.25em] text-foreground-500">{kicker}</span>
      </div>
      <h2 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && (
        <p className={`mt-3 text-sm text-foreground-600 md:text-base ${isCenter ? 'mx-auto max-w-xl' : 'max-w-2xl'}`}>
          {desc}
        </p>
      )}
    </div>
  );
}